import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import locales from './locales'
import 'animate.css';

createApp(App)
.use(store)
.use(router)
.use(locales)
.mount('#app')
